/* eslint-disable no-unused-vars */
import {
  intCol,
  numCol,
  strCol,
  dateTimeCol,
} from '@integec/grid-tools/lib/cols'
import React from 'react'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'

import { monthsMap, yesNoMap, yesNoYNMap } from 'core'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'

export const Wind2TmpImpactSummaryHeaders = [
  // strCol({
  //   ident: 'tabId',
  //   display: 'TabId',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
  intCol({
    ident: 'year',
    display: 'Year',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    isFiltered: true,
    // sortOrder: 'asc',
    ...toSelectionColProps(monthsMap),
  }),
  // strCol({
  //   ident: 'description',
  //   display: 'Description',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
  strCol({
    ident: 'nercEventsImpact',
    display: 'NERC Events Impact',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 150,
  }),
  strCol({
    ident: 'turbineEventsImpact',
    display: 'Turbine Events Impact',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 150,
  }),
  strCol({
    ident: 'nercHrsImpact',
    display: 'NERC Hrs Impact',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 150,
  }),
  strCol({
    ident: 'turbineHrsImpact',
    display: 'Turbine Hrs Impact',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 150,
  }),

  strCol({
    // Wind sir return impactYn is only to take decision that need to show dialog or not and its same for all month
    ident: 'impactYn',
    display: 'General Impact',
    isFiltered: true,
    // sortOrder: 'asc',
    // ...toSelectionColProps(yesNoYNMap),
    dataGetter: ({ rowData, header }) =>
      parseInt(rowData.turbineHrsImpact) > 0 ||
      parseInt(rowData.turbineEventsImpact) > 0 ||
      parseInt(rowData.nercEventsImpact) > 0 ||
      parseInt(rowData.nercHrsImpact) > 0
        ? 'Yes'
        : 'No',
  }),
  strCol({
    ident: 'impactYn',
    display: 'NERC Impact',
    isFiltered: true,
    // sortOrder: 'asc',
    dataGetter: ({ rowData, header }) =>
      parseInt(rowData.nercEventsImpact) > 0 ||
      parseInt(rowData.nercHrsImpact) > 0
        ? 'Yes'
        : 'No',
  }),
  // strCol({
  //   ident: 'recordid',
  //   display: 'Recordid',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
  // strCol({
  //   ident: 'action',
  //   display: 'Action',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
].map(h => ({ ...h, ellipsis: true }))

export const Wind2TmpTurbineEventImpactHeaders = [
  strCol({
    ident: 'turbineId',
    display: 'Turbine Id',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 150,
    // ellipsis: true,
  }),
  strCol({
    ident: 'eventId',
    display: 'Event Id',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  dateTimeCol({
    ident: 'eventstart',
    display: 'Event Start',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
    dataFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'eventend',
    display: 'Event End',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
    dataFormat: 'MM/DD/YYYY HH:mm',
  }),
  strCol({
    ident: 'eventtype',
    display: 'Event Type',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  intCol({
    ident: 'causecode',
    display: 'Cause Code',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'operation',
    display: 'Operation',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  // strCol({
  //   ident: 'recordid',
  //   display: 'Recordid',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
  // strCol({
  //   ident: 'action',
  //   display: 'Action',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
].map(h => ({ ...h, ellipsis: true }))

export const Wind2TmpNercEventImpactHeaders = [
  strCol({
    ident: 'eventId',
    display: 'Event Id',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  dateTimeCol({
    ident: 'eventstart',
    display: 'Event Start',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
    dataFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'eventend',
    display: 'Event End',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
    dataFormat: 'MM/DD/YYYY HH:mm',
  }),
  strCol({
    ident: 'eventtype',
    display: 'Event Type',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  intCol({
    ident: 'causecode',
    display: 'Cause Code',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'operation',
    display: 'Operation',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  // strCol({
  //   ident: 'recordid',
  //   display: 'Recordid',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
  // strCol({
  //   ident: 'action',
  //   display: 'Action',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
].map(h => ({ ...h, ellipsis: true }))

export const Wind2TmpTurbineHoursImpactHeaders = [
  strCol({
    ident: 'turbineId',
    display: 'Turbine Id',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 150,
    // ellipsis: true,
  }),
  strCol({
    ident: 'year',
    display: 'Year',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'month',
    display: 'Month',
    isFiltered: true,
    // sortOrder: 'asc',
    ...toSelectionColProps(monthsMap),
  }),
  strCol({
    ident: 'dataItem',
    display: 'Data Item',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 250,
  }),
  numCol({
    ident: 'beforeReload',
    display: 'Before Reload',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  numCol({
    ident: 'afterReload',
    display: 'After Reload',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'operation',
    display: 'Operation',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  // strCol({
  //   ident: 'recordid',
  //   display: 'Recordid',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
  // strCol({
  //   ident: 'action',
  //   display: 'Action',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
].map(h => ({ ...h, ellipsis: true }))

export const Wind2TmpNercHoursImpactHeaders = [
  intCol({
    ident: 'subgroupId',
    display: 'Subgroup Id',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 200,
    // ellipsis: true,
  }),
  strCol({
    ident: 'year',
    display: 'Year',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'month',
    display: 'Month',
    isFiltered: true,
    // sortOrder: 'asc',
    ...toSelectionColProps(monthsMap),
  }),
  strCol({
    ident: 'dataItem',
    display: 'Data Item',
    isFiltered: true,
    // sortOrder: 'asc',
    width: 250,
  }),
  numCol({
    ident: 'beforeReload',
    display: 'Before Reload',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  numCol({
    ident: 'afterReload',
    display: 'After Reload',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'operation',
    display: 'Operation',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  // strCol({
  //   ident: 'recordid',
  //   display: 'Recordid',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
  // strCol({
  //   ident: 'action',
  //   display: 'Action',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
].map(h => ({ ...h, ellipsis: true }))
